import React from 'react';

type ChevronIconProps = {
    size: number,
    rotate: boolean,
    style?: string
}

const ChevronIcon = ({ size, rotate, style }: ChevronIconProps) => {

    const s = size * 4 + 'px';
    const rotation = rotate ? -180 : 0;
    let styling = 'inline-block transition-slow ';
    if (style) styling += style

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={styling} style={{ width: s, height: s, transform: `rotate(${rotation}deg)`}}>
            <path fillRule="evenodd" d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z" clipRule="evenodd" />
        </svg>
    )
}

export default ChevronIcon